import React from 'react';
import { Fragment } from "react";
import GPAP_Button from "../../../../../gpap-lib/Button_Collection";
import Link from '@mui/material/Link';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Browse Button to go back or to Phenostore
const BrowseButtons = (props) => {

    const origin  = window.location.origin;

    return (
        <Fragment>
            <div style={{float:"left"}}>
                <GPAP_Button href = "#/experiments"  startIcon={<ArrowBackIcon />}>
                    Go to Experiments View
                </GPAP_Button>        
            </div>

            <div style={{float:"left", padding: "4px", marginLeft: "10px"}}>
                <Link href = {origin + "/phenostore/#/summary/" + props.ExperimentInformation.Participant_ID } target={"_blank"}>
                    <AssignmentIndIcon/> Go to Participant Summary
                </Link>
            </div>
        </Fragment>
    );           
}

export default BrowseButtons;